<template>
  <section>
    <Toolbar>
      <template slot="actions">
        <Dialog v-if="item.errorErp" color="error">
          <template #buttonContent>
            <v-icon size=18 class="mr-1">mdi-alert-outline</v-icon>
            Ver Erros do Erp
          </template>
          <template #title>Erros do ERP</template>
          <template #content><span class="wp-preline">{{item.errorErp}}</span></template>
        </Dialog>

        <Dialog v-if="item.justifyApproval" color="yellow darken-3">
          <template #buttonContent>
            <v-icon size=18 class="mr-1">mdi-comment-eye-outline</v-icon>
            Justificativa
          </template>
          <template #title>Justificativa Aprovação/Reprovação</template>
          <template #content><span class="wp-preline">{{item.justifyApproval}}</span></template>
        </Dialog>
        
        <template v-if="['users', 'userRules', 'integrations'].includes(collection)">
         <v-btn v-if="!readonlyComputed" @click="submit()" height=40 x-small outlined color="success" class="mr-2 text-caption">
            <v-icon size=20 class="mr-1">mdi-content-save-outline</v-icon>
            Gravar
          </v-btn>
          
          <v-btn v-if="!readonlyComputed" @click="goBack" height=40 x-small outlined color="error" class="text-caption">
            <v-icon size=18 class="mr-1">mdi-cancel</v-icon>
            Cancelar
          </v-btn>
        
          <v-btn v-else @click="goBack" height=40 x-small outlined color="primary" class="text-caption">
            <v-icon size=18 class="mr-1">mdi-chevron-left</v-icon>
            Voltar
          </v-btn>
        </template>
        <template v-else>
          <v-dialog v-if="computedExportPdf" v-model="jsPdf.dialog" @update:return-value="jsPdf.doc = null" scrollable>
            <template #activator="{ attrs }">
              <v-btn
                height=40
                x-small
                outlined
                color="warning"
                class="mr-2 text-caption"
                @click="generatePdf()"
                v-bind="attrs"
                >
                <v-icon size=20 class="mr-1">mdi-file-pdf-outline</v-icon>
                Exportar PDF
              </v-btn>    
            </template>
            <v-card>
              <v-toolbar flat>
                <v-card-title class="pl-0">Pré-visualização do documento</v-card-title>
                <v-spacer/>
                <v-btn @click="savePdf()" height=40 x-small outlined color="warning" class="mr-2 text-caption">
                  <v-icon size=20 class="mr-1">mdi-file-download-outline</v-icon>
                  Download
                </v-btn>
                <v-dialog
                  v-model="jsPdf.sendEmail.dialog"
                  @input="jsPdfHandleDialog"
                  max-width="50vw">
                  <template #activator="{ attrs, on }">
                    <v-btn
                      height=40
                      x-small
                      outlined
                      color="success"
                      class="mr-2 text-caption"
                      v-bind="attrs"
                      v-on="on"
                      >
                      <v-icon size=20 class="mr-1">mdi-email-send-outline</v-icon>
                      Enviar por Email
                    </v-btn>
                  </template>
                  <Form
                    :inputs="jsPdf.sendEmail.inputs"
                    :model="jsPdf.sendEmail.model"
                    @submit="sendPdf"
                  >
                    <template #prepend>
                      <v-card-title>Enviar documento PDF por email</v-card-title>
                      <v-divider/>
                    </template>
                    <template #append>
                      <v-divider/>
                      <v-card-actions>
                        <v-spacer/>
                        <v-btn
                          :loading="jsPdf.sendEmail.sending"
                          :disabled="jsPdf.sendEmail.sending"
                          type="submit"
                          class="text-caption"
                          color="success"
                          height=40
                          x-small
                          outlined
                          >
                          <v-icon size=20 class="mr-1">mdi-send</v-icon>
                          Enviar
                        </v-btn>
                        <v-btn @click.stop="jsPdf.sendEmail.dialog = false" height=40 x-small outlined color="error" class="text-caption">
                          <v-icon size=18 class="mr-1">mdi-cancel</v-icon>
                          Cancelar
                        </v-btn>
                      </v-card-actions>
                    </template>
                  </Form>
                </v-dialog>
                <v-btn @click.stop="jsPdf.dialog = false" height=40 x-small outlined color="error" class="text-caption">
                  <v-icon size=18 class="mr-1">mdi-cancel</v-icon>
                  Cancelar
                </v-btn>
              </v-toolbar>
              <v-divider/>
              <Iframe v-if="!!jsPdf.doc" :src="jsPdfOutput" type="application/pdf"/>
              <v-divider/>
            </v-card>
          </v-dialog>
        
          <v-btn v-if="collection.includes('SC5') && item.C5_NUM && (!item.C5_YPEDORI || item.C5_YPEDORI === '') && (! $appConfig.claims || $appConfig.claims.bonus ) && computedClaims.add" 
            @click="goBonus" height=40 x-small outlined color="indigo accent-6" class="mr-2 text-caption">
            <v-icon size=18 class="mr-1">mdi-gift</v-icon>
            Bonificar PV
          </v-btn>

          <v-btn v-if="!readonlyComputed && collection.includes('SC5')  && (! $appConfig.claims || $appConfig.claims.approval ) && !item.submitToApproval && needApproval"              
            @click="submit({submitToApproval: true})" height=40 x-small outlined color="primary" class="mr-2 text-caption">
            <v-icon size=18 class="mr-1">mdi-file-check-outline </v-icon>
            Solicitar Aprovação
          </v-btn>

          <v-dialog
            v-model="approval.dialog"            
            max-width="50vw">
            
            <v-form
              ref="formApproval"
              v-model="approval.valid"        
              @submit.prevent="sendApproval">

              <v-card>
                <v-card-title>Aprovar / Reprovar</v-card-title>
                <v-divider/>                

                <v-card-text>
                  <v-textarea                
                    v-model="approval.model.justify"
                    name="justify"
                    :rules="[v => !!v || 'Justificativa é obrigatória']"
                    label="Justificativa"
                    rows="4"                
                    auto-grow
                  ></v-textarea>
                </v-card-text>

                <v-divider/>
                <v-card-actions>
                  <v-spacer/>
                  <v-btn
                    :loading="approval.sendApproval"
                    :disabled="!approval.valid"
                    type="submit"
                    class="text-caption"
                    color="success"
                    height=40
                    @click="approval.model.status = true"
                    x-small
                    outlined
                    >
                    <v-icon size=20 class="mr-1">mdi-check</v-icon>
                    Aprovar
                  </v-btn>
                  <v-btn 
                    :loading="approval.sendApproval"
                    :disabled="!approval.valid"
                    type="submit"
                    class="text-caption"                    
                    height=40
                    @click="approval.model.status = false"
                    x-small
                    outlined
                    color="error">
                    <v-icon size=18 class="mr-1">mdi-cancel</v-icon>
                    Reprovar
                  </v-btn>
                  <v-btn @click="approval.dialog = false" height=40 x-small outlined  class="text-caption">
                    <v-icon size=18 class="mr-1">mdi-close</v-icon>
                    Fechar
                  </v-btn>
                </v-card-actions>

              </v-card>

            </v-form>
          </v-dialog>

         <v-dialog
            v-model="upload.dialog"            
            max-width="50vw">
            
            <v-form
              ref="formUpload"
              v-model="upload.valid"        
              @submit.prevent="sendUpload">

              <v-card>
                <v-card-title>Itens em anexo</v-card-title>
                <v-divider/>                
                <v-list>
                  <!-- <v-subheader v-if="files.length!=0">Itens já anexados</v-subheader> -->
                  <v-list-item 
                    v-for="(file, key) in files"
                    :key="file+key">
                    <v-list-item-content>
                      <v-list-item-title>{{file.ACB_CODOBJ}}</v-list-item-title>
                      <v-list-item-subtitle>{{file.ACB_DESCRI}}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                      <v-icon  
                          color="blue accent-2"
                          v-bind="attrs"
                          v-on="on"
                          @click="downloadFile(file.ACB_CODOBJ, file.ACB_DESCRI)">
                          mdi-file-download                          
                      </v-icon>
                       </template>
                        <span>Download</span>
                    </v-tooltip>
                    </v-list-item-icon>
                  </v-list-item>              
                </v-list>  
                <v-divider/>                                 
                <template>
                  <v-file-input
                    v-model="fileUpload.file"
                    name="file"                    
                    label="Clique para incluir um novo anexo"                    
                    placeholder="Selecionar arquivo"
                    prepend-icon="mdi-paperclip"
                    outlined
                    :show-size="1000"
                    class="mr-2 ml-2 mt-2"                    
                  >
                    <template v-slot:selection="{ index, text }">
                      <v-chip
                        v-if="index < 2"                        
                        dark
                        label
                        small
                      >
                      {{ text }}
                      </v-chip>
                    </template>
                  </v-file-input>        

                </template>                

                <v-card-actions>
                  <v-spacer/>
                  <v-btn 
                     :loading="fileUpload.sending"
                     :disabled="!fileUpload.file"
                      type="submit"
                      class="text-caption"                    
                      height=40
                      x-small
                      outlined
                      color="blue">
                      <v-icon size=18 class="mr-1">mdi-cloud-upload</v-icon>
                      Upload
                    </v-btn>          
                  <v-btn @click="upload.dialog = false" height=40 x-small outlined  class="text-caption">
                    <v-icon size=18 class="mr-1">mdi-close</v-icon>
                    Fechar
                  </v-btn>

                </v-card-actions>

              </v-card>

            </v-form>
          </v-dialog>

          <v-btn v-if="entityField" :disabled="!item.id"              
            @click="uploadOpenForm" height=40 x-small outlined color="primary" class="mr-2 text-caption">
            <v-icon size=18 class="mr-1">mdi-paperclip </v-icon>            
            Anexos
          </v-btn>

          <v-btn v-if="collection.includes('SC5')  && (! $appConfig.claims || $appConfig.claims.approval ) && computedClaims.approval && item.submitToApproval"              
            @click="approvalOpenForm" height=40 x-small outlined color="primary" class="mr-2 text-caption">
            <v-icon size=18 class="mr-1">mdi-file-check-outline </v-icon>
            Aprovar/Reprovar
          </v-btn>

          <v-btn v-if="!readonlyComputed && computedClaims.add" :disabled="!validatedDetails" @click="submit()" height=40 x-small outlined color="success" class="mr-2 text-caption">
            <v-icon size=20 class="mr-1">mdi-content-save-outline</v-icon>
            Gravar Rascunho
          </v-btn>
          
           <!--TODO VERIFICAR DEPOIS PARA TIRAR AMARRAÇÃO DA NAO APROVACAO QUANDO FOR CLIENTE(SA1)-->
          <v-btn v-if="!readonlyComputed && computedClaims.sync && (!needApproval || collection.includes('SA1')) " :disabled="!validatedDetails" @click="submit({submitToErp: true})" height=40 x-small outlined color="primary" class="mr-2 text-caption">
            <v-icon size=20 class="mr-1">mdi-file-send-outline</v-icon>
            Gravar para Envio
          </v-btn>
          
          <v-btn v-if="!readonlyComputed" @click="goBack" height=40 x-small outlined color="error" class="text-caption">
            <v-icon size=18 class="mr-1">mdi-cancel</v-icon>
            Cancelar
          </v-btn>
        
          <v-btn v-else @click="goBack" height=40 x-small outlined class="text-caption">
            <v-icon size=18 class="mr-1">mdi-chevron-left</v-icon>
            Voltar
          </v-btn>
        </template>
      </template>
    </Toolbar>
    <Form
      :inputs="computedInputsMaster"
      :collection="collection"
      :model="item"
      :color="color"
      :readonly="readonlyComputed"
      @submit="submit()"
      ref="formMaster"
    ></Form>

    <!-- IMPOSTOS -->
    <v-card v-if="collection.includes('SC5')" class="mt-6">
      <v-card-text>
        <v-toolbar flat dense short height=35>
          <v-toolbar-title :class="`subtitle-2 font-weight-bold ${color}--text ml-n4`">Impostos</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!item.bloqueado"
            @click="calcImps()" 
            small 
            outlined
            :disabled="impostos.loading"
            color="primary" 
            class="no-hover mr-n4">
            Calcular Impostos
          </v-btn>
        </v-toolbar>
        <v-data-table
          :headers="impostos.headers"
          :items="impostos.itens"
          :loading="impostos.loading"
          hide-default-footer
          disable-sort
          dense
          loading-text="Calculando... Por favor aguarde"
        >
          <!-- ITEM -->
          <template v-slot:item="{item, index, headers}">
            <tr>  
              <v-alert v-if="item.Erros || item.ERROS || item.erros" :value="true" dark color="error" icon="mdi-alert-outline" class="mt-3">
                <span class="wp-preline">{{item.Erros || item.ERROS || item.erros}}</span>
              </v-alert>
              <template v-else>
                <td
                  v-for="(header, key) in headers"
                  :key="index+key"
                  class="text-center"
                  >
                   {{   typeof  item[header.value] == 'string' ? item[header.value] : 'R$ ' + item[header.value].toLocaleString('pt-br', { minimumFractionDigits:2, maximumFractionDigits: 2 }) }}
                </td>
              </template>
            </tr>
          </template>

          <!-- No Results  -->
          <template v-slot:no-data>
            {{impostos.noData}}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <FormDataTable
      v-if="typeDetails == 'data-table'"
      :headers="computedHeaders"
      :items="inputsDetails"
      :filters="computedFilters"
      :xlsxName="xlsxName"
      :color="color"
      :readonly="readonlyComputed"
      @submit="submit()"
      @validated="validatedDetails = $event"
      ref="formDetails"
      :formMaster="$refs.formMaster"
    ></FormDataTable>
  </section>
</template>

<script>
import Toolbar from "@/components/Templates/Toolbar"
import Dialog from "@/components/Templates/Dialog"
import { createNamespacedHelpers, mapActions, mapMutations, mapState } from 'vuex'
const { mapState:registersState, mapActions:registersActions } = createNamespacedHelpers('registers')
const { mapState:authState } = createNamespacedHelpers('auth')
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import Form from "@/components/Registers/Form"
import FormDataTable from "@/components/Registers/FormDataTable"
import Iframe from "@/components/Templates/Iframe"
import axios from 'axios'
export default {
  name: 'Register',
  components: { Form, FormDataTable, Toolbar, Dialog, Iframe },
  props: {
    name: {
      type: String,
      required: false,
    },
    collection: {
      type: String,
      required: true,
    },
    register: {
      type: String,
      required: true,
    },
    inputsMaster: {
      type: Array,
      default: () => []
    },
    blockedField: String,
    entityField: String,
    color: {
      required: false,
      type: String,
      default: "indigo"
    },
    readonly: {
      required: false,
      type: Boolean,
      default: () => false
    },
    edit: {
      required: false,
      type: Boolean,
      default: () => false
    },
    integration: {
      required: false,
      type: Boolean,
      default: () => false
    },
    dispatch: {
      type: Array,
      default: () => []
    },
    collectionDetails: {
      required: false,
      type: String,
    },
    headersDetails: {
      type: Array,
      default: () => []
    },
    tableCollection: {
      type: String,
      default: ""
    },
    tableSubcollection: {
      type: String,
      default: ""
    },
    orderSubcollection: {
      required: false,
    },
    tableIdFrom: {
      type: String,
      default: ""
    },
    filtersDetails: {
      type: Array,
      default: () => []
    },
    filterItems: String,
    xlsxName: String,
    typeDetails: String,
    impostosPdfText: String,
    totaisPdfText: String,
    colorPdfTable: String,
    claims: {
      type: Object,
      required: true,
      default: () => ({
        add: false, 
        view: false, 
        edit: false, 
        delete: false, 
      })
    },
    exportPdf: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  data() {
    return {
      ready: false,
      item: {},
      itemsDetails: [],
      tableItems: [],
      autoSave: {
        active: true,
        firstSaveTime: 5 * 1000,
        saveTime: 60 * 1000,
        timer: null
      },
      impostos: {
        headers: [],
        itens: [],
        noDataDefault: 'Não há dados disponíveis',
        noData: 'Não há dados disponíveis',
        loading: false,
      },
      jsPdf: {
        doc: null,
        dialog: false,
        sendEmail: {
          sending: false,
          dialog: false,
          inputs: [
            { type: 'text-field', value: 'to', label: "Email de Destino" },
            { type: 'text-field', value: 'cc', label: "Cc", md: 6 },
            { type: 'text-field', value: 'bcc', label: "Cco", md: 6 },
            { type: 'text-field', value: 'subject', label: "Assunto" },
            { type: 'textarea', value: 'text',  label: "Corpo do Email", rows: 4 },
          ],
          model: null,
        }
      },
      approval: {
        sendApproval: false,
        valid: true,
        dialog: false,
        model: {},
      },
      fileUpload: {},
      upload: {
        dialog: false
      },
      files: [],  
      validatedDetails: false,
      needApproval: true,

      /**
       * @TODO
       * Código provisório, remover assim que possível
       * Guarda o valor do atributo 'A1_XPTDESC' do cliente selecionado em 'SA1' no form cabelalho
       */
      A1_XPTDESC: null
    }
  },

  computed: {
    ...registersState(['registers']),
    ...mapState(['companies']),
    ...authState(['user']),

    readonlyComputed() {
      const readOnly = (this.item && this.blockedField && !(this.id && this.claimRoute === 'add')) ? this.item[this.blockedField] || this.readonly : this.readonly
      return readOnly        
    },

    computedInputsMaster() {
      return this.inputsMaster.map( i => {
        const input = { ...i }

        if (input.set)
          input.set = eval(input.set)

        if (input.computed) {
          input.computed = eval(input.computed)
        }

        if (typeof input.itemText == 'string' && input.itemText.includes('=>'))
          input.itemText = eval(input.itemText)
        
        if (input.model) 
          input.model = eval(input.model)

        if (input.rules) {
          input.rules.forEach((el, ix) => {
            input.rules[ix] = eval(el)
          });
        }

        if (input.markers)
          input.markers = Object.entries(input.markers).reduce((acc, [key, val]) => ({...acc, [key.trim().toLocaleLowerCase()]: val}), {})
        
        // envia todos os campos caso esteja cadastrando
        if (!this.id)
          input.send = true

        if (typeof input.hide == 'string' && input.hide.includes('=>'))
          input.hide = eval(input.hide)

        return input
      })
    },

    inputsDetails: {
      get() {
        if (this.readonlyComputed)
          return this.itemsDetails

        return this.itemsDetails.length > 0
          ? this.tableItems.map(item => this.itemsDetails.find(_item => this.headersDetails.filter(h => h.identifier).every(h => item[h.value] == _item[h.value])) || item)
          : this.tableItems
      },
      set(value) {
        this.itemsDetails = value
      }
    },

    id() {
      return this.$route.params.id || this.item.id
    },

    claimRoute() {
      return this.$route.meta.claimRoute
    },

    computedHeaders() {
      return this.headersDetails.map(h => {
        const header = { ...h }

        if (header.set)
          header.set = eval(header.set)

        if (header.computed) 
          header.computed = eval(header.computed)
        
        if (header.validation && Array.isArray(header.validation))
          header.validation = header.validation.map(strFn => eval(strFn))
        
        /**
         * @TODO
         * Código provisório, remover assim que possível
         * Altera os valores default e a função SET para mudar os limites da coluna de desconto
         */
        if (this.A1_XPTDESC && header.value == 'C6_XDESCON') {
          header.default = this.A1_XPTDESC
          header.set = ({ value }) => Math.min(this.A1_XPTDESC, Math.max(0, value))
        }

        return header
      })
    },

    computedDispatch() {
      return this.dispatch
    },

    computedFilters() {
      return this.filtersDetails.map(filter => {
        if (filter.filter)
          filter.filter = eval(filter.filter)
          
      })
    },

    filterItemsFunction() {
      const _default = _ => true
      try {
        const val = eval(this.filterItems)
        if (!val || !val.apply)
          return _default
        
        return val
      } catch(err) {
        return _default
      }
    },

    method() {
      return this.edit ? 'edit' : 'new'
    },

    jsPdfOutput() {
      if (this.jsPdf.doc)
        return this.jsPdf.doc.output('datauristring')
      else
        return null
    },

    company() {
      return this.companies.find(c => c.id == `${this.item.gpEmpresa}${this.item.filial}`)
    },

    computedClaims() {
      let claims = this.claims

      claims.view = (claims.view && this.user?.claims?.admin) || this.user?.rules.some(x => x.claims && x.claims[this.register] && x.claims[this.register]?.view)
      claims.add = (claims.add && this.user?.claims?.admin) || this.user?.rules.some(x => x.claims && x.claims[this.register] && x.claims[this.register]?.add)
      claims.sync = (claims.sync && this.user?.claims?.admin) || this.user?.rules.some(x => x.claims && x.claims[this.register] && x.claims[this.register]?.sync)
      claims.edit = (claims.edit && this.user?.claims?.admin) || this.user?.rules.some(x => x.claims && x.claims[this.register] && x.claims[this.register]?.edit)
      claims.delete = (claims.delete && this.user?.claims?.admin) || this.user?.rules.some(x => x.claims && x.claims[this.register] && x.claims[this.register]?.delete)
      claims.approval = (claims.approval && this.user?.claims?.admin) || this.user?.rules.some(x => x.claims && x.claims[this.register] && x.claims[this.register]?.approval)

      return claims
    },
    computedExportPdf() {            

      let generatePdfDraft = true;
      
      if (this.collection.includes('SC5') && this.$appConfig.claims.generatePdfDraft != undefined  && !this.$appConfig.claims.generatePdfDraft && this.item.status == 'Rascunho' ) generatePdfDraft = false
      
      return this.readonlyComputed && this.exportPdf && generatePdfDraft
},
  },

  methods: {
    ...mapActions(['dispatchAction']),
    ...registersActions(['save', 'getById', 'get', 'getGpEmpresa', 'observer', 'calculaImpostos', 'sendFile', 'getFiles', 'getFile']),
    ...mapMutations(['setLoading']),
    
    async submit(params = {}) {
      const {submitToErp = false, submitToApproval = false} = params
      if (this.readonlyComputed) {
        this.goBack()
        return
      }

      if (this.validate()) {
        try {
          const response = await this.send({submitToErp, submitToApproval})
          this.goBack()
        } catch (err) {
          console.error(err)
        }
      }
    },

    validate() {      
      return this.$refs.formMaster.validate() && (this.typeDetails != 'data-table' || this.$refs.formDetails.validate())
    },

    async calcImps(impostos) {      
      if (!impostos) {        
        this.impostos.itens = []
        this.impostos.noData = this.impostos.noDataDefault
        this.impostosMessage = 'Calculando...'
        const item = this.$refs.formMaster.getModel()
        const itemsDetails = this.$refs.formDetails.getModel().filter(this.filterItemsFunction).map(item => ({data: item}))
        if (!itemsDetails || !itemsDetails.length > 0) return this.impostos.noData = 'Não foi preenchido nenhum produto no pedido'
        this.impostos.loading = true
        impostos = await this.calculaImpostos({
          item,
          itemsDetails,
          collectionDetails: this.collectionDetails,
        })
        if(impostos.response && impostos.response.status == 500) 
          impostos = {Erros: impostos.response?.data?.error || 'Requisição cancelada, servidor Protheus offline.'}
        
        if(impostos.code == 'ECONNABORTED') impostos = {Erros: 'Requisição cancelada, tempo excedido.'}
      }      
      
      let impHeaders
      
      if (impostos && impostos.itens) {
          this.impostos.itens = impostos.itens
          impHeaders = impostos.itens[0]
      } else {        
        this.impostos.itens.push(impostos)
        impHeaders = impostos
      }
      
      this.impostos.headers = Object.entries(impHeaders).sort((a, b) => (a[0] < b[0]) ? -1 : (a[0] > b[0]) ? 1 : 0).map(x => ({align: 'center', text: x[0], value: x[0]}))
      this.impostos.noData = this.impostos.noDataDefault
      this.impostos.loading = false
    },

    async send({submitToErp, submitToApproval, item}) {
      
      if (! item ) item = this.$refs.formMaster.getModel()

      if (item.dataFilters) item.dataFilters = item.dataFilters.filter(filter => !filter.delete)

      if (this.impostos && this.impostos.itens && this.impostos.itens.length > 0) item.impostos = this.impostos

      let itemsDetails
      if (this.typeDetails == 'data-table')
        itemsDetails = this.$refs.formDetails.getModel().filter(this.filterItemsFunction).map(item => ({data: item}))
      
      if (this.collectionDetails && (!itemsDetails || !itemsDetails.length > 0)) {
        this.$toast.error('Itens não informados.', {position: 'top-right'})
        throw 'Itens não informados.'
      }

      const id = this.id
      if (!item.id && id)
        item.id = id

      // Dispatch Before
      if (this.computedDispatch.length > 0) {
        this.computedDispatch.filter(x => x.when == 'before' && x.method == this.method).forEach(el => {
          if (!el.switch || item[el.switch]) {
            this.dispatchAction({action: el.action, params: this.proccessParams({params: el.params, item})})
          }
        });
      }

      const response = await this.save({
        integration: this.integration,
        collection: this.collection,
        collectionDetails: this.collectionDetails,
        item,
        itemsDetails,
        submitToErp,
        submitToApproval
      })
      
      // Dispatch After
      if (this.computedDispatch.length > 0) {
        this.computedDispatch.filter(x => x.when == 'after' && x.method == this.method).forEach(el => {
          if (!el.switch || item[el.switch]) {
            this.dispatchAction({action: el.action, params: this.proccessParams({params: el.params, item})})
          }
        });
      }

      return response
    },

    proccessParams({item, params}) {
      const ret = {}
      for (const key in params) {
        if (Object.prototype.hasOwnProperty.call(params, key)) {
          const el = params[key]
          const pathItem = el.split('.')
          const lenItem = pathItem.length
          if (lenItem == 1) {
            ret[key] = pathItem[0]
          } else {
            for (let ix = 1; ix < pathItem.length; ix++) {
              const el2 = pathItem[ix];
              if (typeof item[el2] != 'undefined') { ret[key] = item[el2] }
              else { ret[key] = '' ; break }
            }
          }
        }
      }
      return ret
    },

    goBack() {
      this.$router.push(`/${this.register}/listar`)
    },

    goBonus() {
      this.$router.push(`/${this.register}/bonificar/${this.item.id}`)
    },

    handleItem(item) {
      return item
    },

    async fetchDetails() {
      if (!this.collection || !this.$route.params.id || !this.collectionDetails) {
        this.ready = true
        return
      }

      const collection = this.collection+await this.getGpEmpresa(this.collection)
      const collectionDetails = this.collectionDetails+await this.getGpEmpresa(this.collectionDetails)
      const ref = this.$db().collection(collection).doc(this.$route.params.id).collection(collectionDetails)
      const res = await this.get({collection, ref, limit: 200})
      if (res)
        this.itemsDetails = res
      this.ready = true
      return res
    },

    startAutoSave() {
      this.autoSave.timer = setTimeout(this.tryAutoSave, this.autoSave.firstSaveTime)
    },

    async tryAutoSave() {
      this.autoSave.timer = null
      try {
        const response = await this.send()
        this.$set(this.item, 'id', response.data.data.id)
      } catch (err) {
        console.error(err)
      } finally {
        this.autoSave.timer = setTimeout(this.tryAutoSave, this.autoSave.saveTime)
      }
    },

    /**
     * Transforma { a: { b: 1 } } em {'a.b': 1}
     * Ps: Funciona apenas para um nível de objeto
     * @TODO Generalizar para mais níveis
     * @TODO Funcionar com arrays.
     */
    normalizeItem(item) {
      Object.entries(item).forEach(([key,val]) => {
        if (typeof val == 'object' && val) {
          Object.entries(val).forEach(([k, v]) => {
            if (typeof v == 'object' && v) {
              Object.entries(v).forEach(([i, j]) => {
                const newKey = key + '.' + k + '.' + i
                item[newKey] = j
              })
            }
            const newKey = key + '.' + k
            item[newKey] = v
          })
        } 
      })
    },

    async getTableItems({collection, id, subCollection, orderSubcollection}) {
      subCollection = subCollection+await this.getGpEmpresa(subCollection)
      const response = await this.getById({collection, id, subCollection, orderSubcollection, setRegister: false})

      if (!response) return this.tableItems = []
      
      const subCollectionItems = response[subCollection]
      delete response[subCollection]

      if (!response || !subCollectionItems || !subCollectionItems.length > 0) return this.tableItems = []

      this.tableItems = subCollectionItems.map(item => {
        let filteredItem = {}
        this.headersDetails.forEach(header => {
          filteredItem[header.value] = (header.fill && item[header.fill]) ? item[header.fill] : item[header.value]
          
          if (!filteredItem[header.value])
            filteredItem[header.value] = header.default //this.$refs.formDetails.save(item, header, header.default)
        })
        return filteredItem
      })
    },

    /**
     * Gera o pdf para ser exibido na tela e posteriormente baixado enviado por email
     */
    async generatePdf() {
      this.setLoading({stats: true})
      try {
        const doc = new jsPDF();
        const fontSize = 7
        let lineHeight = fontSize
        const fontFamily = "helvetica"
        const tableLineWidth = 0.2
        const tableLineColor = [125, 125, 125]
        const hexToNumber = str => eval('0x' + str)
        const fillColor = this.colorPdfTable && [
          hexToNumber(this.colorPdfTable.slice(1,3)),
          hexToNumber(this.colorPdfTable.slice(3,5)),
          hexToNumber(this.colorPdfTable.slice(5,7)),
        ] || [ 41, 128, 186] // azul padrão de header
  
        
        // altere o valor para determinar qual linha deve começar o documento
        let line = 2
  
        const size = {
          x: 210,
          y: 297 
        }
  
        const item = this.$refs.formMaster.getModel()
  
        /**
         * Logo
         * addImage ref: https://artskydj.github.io/jsPDF/docs/module-addImage.html
         */
        const image = await this.loadImage()
        doc.addImage(image, 'JPEG', 5, lineHeight, 12, 12)
  
        /**
         * Título
         */
        doc.setFont(fontFamily)
        doc.setFontSize(2.5 * fontSize)
        /** @TODO parametrizar o título */
        doc.text(`Pedido ${item.id}`, size.x/2, line * lineHeight, { align: 'center' });
        doc.setFontSize(fontSize)
        line++
  
        /**
         * Empresa
         */
        const colsEmpresa = 3
        const company = this.company
        const empresaItems = [
          { label: 'Empresa', value: company.M0_NOMECOM.trim(), },
          { label: 'CNPJ', value: company.M0_CGC.trim(), },
          { label: 'Inscrição Estadual', value: company.M0_INSC.trim(), },
          { label: 'Site', value: company.SITE ? company.SITE : 'www.userfunction.com.br' },
          { label: 'E-Mail', value: '', },
          { label: 'Telefone', value: company.M0_TEL.trim(), },
          { label: 'Endereço', value: company.M0_ENDCOB.trim(), },
          { label: 'Bairro', value: company.M0_BAIRCOB.trim(),},
          { label: 'CEP', value: company.M0_CEPCOB.trim(),},
          { label: 'Cidade', value: company.M0_CIDCOB.trim(),},
          { label: 'UF', value: company.M0_ESTCOB.trim(),},
        ]
        const empresaBody = []
        for (let row = 0; row < empresaItems.length / colsEmpresa; row++) {
          const rowInputs = empresaItems.slice(row*colsEmpresa, (row*colsEmpresa) + colsEmpresa)
          empresaBody.push(rowInputs.reduce((acc, item) => {
            const label = {
              content: item.label,
              styles: {
                fillColor,
                textColor: [255, 255, 255], 
                fontStyle: 'bold',
                lineWidth: 0.1,
                lineColor: [171, 206, 228]
              },
            }
            const value = {
              content: item.value,
            }
  
            return [...acc, label, value]
          }, []))
        }
        doc.autoTable({
          startY: line * lineHeight,
          body: empresaBody,
          margin: { top: 25, right: 5, bottom: 10, left: 5 },
          styles: { halign: 'center', fontSize, cellPadding: 1 },
          headStyles: { halign: 'center', fontStyle: 'bold' },
          tableLineWidth,
          tableLineColor,
        })
  
        /**
         * Cabeçalho
         */
        // Define o número de colunas por tabela
        const cols = 3
        const inputs = this.computedInputsMaster.filter(i => (i.value && i.exportPdf !== false && !i.returnObject))
        const body = []
        for (let row = 0; row < inputs.length / cols; row++) {
          const rowInputs = inputs.slice(row*cols, (row*cols) + cols)
          body.push(rowInputs.reduce((acc, input) => {
            let text = item[input.value] || ''
            if (input.type == 'select') {
              const selectItem = input.items.find(i => i.value == item[input.value])
              if (selectItem) 
                text = selectItem.text || item[input.value]
            }

             /**
             * Configuração do Label
             * ref: https://github.com/simonbengtsson/jsPDF-AutoTable#options
             */
            const label = {
              content: input.label,
              styles: {
                fillColor,
                textColor: [255, 255, 255], 
                fontStyle: 'bold',
                lineWidth: 0.1,
                lineColor: [171, 206, 228]
              },
            }
            
            /**
             * Configuração do texto do valor do item
             */
            const value = {              
              content: (typeof text == 'string') ? text.trim() : text,
            }
  
            return [...acc, label, value]
          }, []))
        }
        doc.autoTable({
          startY: doc.lastAutoTable.finalY + lineHeight,
          body,
          margin: { top: 25, right: 5, bottom: 10, left: 5 },
          styles: {
            fontSize,
            cellPadding: 1,
          },
          tableLineWidth,
          tableLineColor,
        })
  
        /**
         * Impostos
         */
        if (this.impostos && this.impostos.headers && this.impostos.headers.length > 0) {
          const head = [
            [{ content: 'Impostos', colSpan: this.impostos.headers.length, styles: { halign: 'center' }}],
            this.impostos.headers.map(el => ({content:el.text}))
          ]

          let impostosBody = []

          this.impostos.itens.forEach(item => {
            impostosBody.push( this.impostos.headers.map(el => {
              const value = item[el.value]
              return `R$ ${value.toLocaleString('pt-br', { minimumFractionDigits:2, maximumFractionDigits: 2 }) }`
            }))            
          });

          doc.autoTable({
            startY: doc.lastAutoTable.finalY + lineHeight,
            head,
            body: impostosBody,
            margin: { top: 25, right: 5, bottom: 10, left: 5 },
            styles: { halign: 'center', fontSize,  cellPadding: 1 },
            headStyles: { halign: 'center', fontStyle: 'bold', fillColor },
            tableLineWidth,
            tableLineColor,
          })
  
          if (this.impostosPdfText)
            doc.text(this.impostosPdfText, 5, doc.lastAutoTable.finalY + (lineHeight/2))
        }
  
        /**
         * Totais Itens
         */
        if  (this.$appConfig.claims.generateTotalPdf != undefined && this.$appConfig.claims.generateTotalPdf)
          this.docPdfTotais(doc, { lineHeight, fontSize, fillColor, tableLineWidth, tableLineColor })
  
        /**
         * Tabela de itens
         */
        const headersItens = this.computedHeaders.filter(header => {
          if ('exportPdf' in header)
            return header.exportPdf === true || header.exportPdf == 'itens'
          else
            return true
        })
        const head = [headersItens.map(h => h.text)]
        const headKeys = headersItens.map(h => h.value)
  
        const table = this.$refs.formDetails.getTable()
        const bodyTableItems = []
        for (const row of table.rows) {
          const item = row.item
          if (!this.filterItemsFunction(item))
            continue
          
          bodyTableItems.push(headKeys.map(header => row.getCellFromHeader(header).text))
        }
  
        // ref: https://github.com/simonbengtsson/jsPDF-AutoTable
        doc.autoTable({
          startY: doc.lastAutoTable.finalY + lineHeight,
          head,
          body: bodyTableItems,
          margin: { top: 25, right: 5, bottom: 10, left: 5 },
          styles: { fontSize, cellPadding: 1  },
          headStyles: { fontStyle: 'bold', fillColor, },
          tableLineWidth,
          tableLineColor,
        })
  
        /**
         * Totais (fim da tabela)
         */
        // this.docPdfTotais(doc, { lineHeight, fontSize, fillColor, tableLineWidth, tableLineColor })
  
        this.jsPdf.doc = doc
        this.jsPdf.dialog = true
      } catch(e) {
        console.error(e)
      } finally {
        this.setLoading({stats: false})
      }
    },

    /**
     * Carrega a imagem da logo da empresa para por no PDF
     */
    async loadImage() {
      let url = require('@/assets/logopdf.png')

      if (this.$appConfig.logopdf) 
        return this.$appConfig.logopdf

      const response = await axios.get(url, { responseType: 'blob' })
      const blob = response.data
      return new Promise((resolve, reject) => {
        var fr = new FileReader();  
        fr.onload = () => {
          resolve(fr.result)
        };
        fr.onerror = reject;
        fr.readAsDataURL(blob);
      });
    },

    docPdfTotais(doc, { lineHeight, fontSize, fillColor, tableLineWidth, tableLineColor }) {
      const headers = this.computedHeaders.filter(header => {
        if ('exportPdf' in header)
          return header.exportPdf === true || header.exportPdf == 'totais'
        else
          return true
      })
      const totalize = this.$refs.formDetails.getTotalize().filter(el => !!headers.find(h => h.value == el.value))
      if (totalize) {
        const head = [
          [{ content: 'Totais', colSpan: totalize.length, styles: { halign: 'center' }}],
          totalize.map(el => el.label)
        ]
        const body = [totalize.map(el => el.text)]
        doc.autoTable({
          startY: doc.lastAutoTable.finalY + lineHeight,
          head,
          body,
          margin: { top: 25, right: 5, bottom: 10, left: 5 },
          styles: { halign: 'center', fontSize, fillColor, cellPadding: 1 },
          headStyles: { halign: 'center', fontStyle: 'bold' },
          tableLineWidth,
          tableLineColor,
        })

        if (this.totaisPdfText)
          doc.text(this.totaisPdfText, 5, doc.lastAutoTable.finalY + (lineHeight/2))
      }
    },

    /** @TODO parametrizar o nome do documento */
    savePdf() {
      if (this.jsPdf.doc)
        this.jsPdf.doc.save("pedido.pdf")
      else
        console.warn('jsPdf.doc not yet defined.')
    },

    async sendPdf({ to, text, bcc, cc, subject }) {
      let response
      try {
        this.jsPdf.sendEmail.sending = true
        response = await this.$api.post(`/mail`, { to, text, id: this.id, bcc, cc, subject, attachment: this.jsPdfOutput })
        
        this.jsPdf.sendEmail.dialog = false
        this.$toast.success('Email enviado!', { position: 'top-right' })
      } catch (err) {
        response = err
      } finally {
        this.jsPdf.sendEmail.sending = false
      }

      return response
    },

    async sendApproval(e) {
      
      if (this.$refs.formApproval.validate()) {
        const item = this.$refs.formMaster.getModel()
        item.justifyApproval = this.approval.model.justify
        item.submitToApproval = false
        item.bloqueado = false
        this.send({submitToErp: this.approval.model.status, item})        
        this.approval.dialog = false;
        this.goBack()        
      }

    },

    async sendUpload(e) {
      const item = this.$refs.formMaster.getModel()
      const fieldfilial = (this.collection[0] == 'S' ? this.collection.substring(1) : this.collection) + '_FILIAL'
      this.fileUpload.sending = true
      await this.sendFile({file: this.fileUpload.file, collection: this.collection, numSite: item.id, entityKey: item[this.entityField], filEnt: item[fieldfilial] })
      this.fileUpload.sending = false
      if (this.$refs.formUpload) this.$refs.formUpload.reset()
      await this.setFilesList(item);
    },

    approvalOpenForm() {
      this.approval.dialog = true;
      if (this.$refs.formApproval) this.$refs.formApproval.reset()
    },

    async uploadOpenForm() {
      await this.setFilesList();
      this.upload.dialog = true;
    },

    async setFilesList(_item) {
      const item = _item || this.$refs.formMaster.getModel()      
      const fieldfilial = (this.collection[0] == 'S' ? this.collection.substring(1) : this.collection) + '_FILIAL'
      this.files = await this.getFiles({collection: this.collection, numSite: item.id, entityKey: item[this.entityField], filent: item[fieldfilial] })      
    }, 

    async downloadFile(codObj, fileName) {
      const item = this.$refs.formMaster.getModel()      
      const ret = await this.getFile({collection: this.collection, codObj, numSite: item.id })            
      if (ret) {
        const linkSource = `data:application/${ret.extension};base64,${ret.file}`;
        const downloadLink = document.createElement("a");  
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();        
      }
    },
    
    jsPdfHandleDialog(value) {
      if (value) {
        const item = this.$refs.formMaster.getModel()

        const integration = this.$integrations.find(i => i.collection === this.collection)
        const { 
          toDefault, 
          subjectDefault,
          textDefault, 
          enableCcDefault: enableCc, 
          ccDefault, 
          enableBccDefault: enableBcc,
          bccDefault
        } = integration?.emailConfigs || { toDefault: '""', textDefault: '""', subjectDefault: '""', enableCcDefault: false, ccDefault: '""', enableBccDefault: false, bccDefault: '""' }

        const to = eval(toDefault)
        const text = eval(textDefault)
        const subject = eval(subjectDefault)
        const cc = eval(ccDefault)
        const bcc = eval(bccDefault)

        /** @TODO parametrizar */
        // const to = item['SA1'] && item['SA1']['A1_EMAILPDF'] && item['SA1']['A1_EMAILPDF'].trim() || ''
        this.jsPdf.sendEmail.model = {
          to,
          text,
          subject,
          cc,
          bcc
        }

        this.jsPdf.sendEmail.inputs = this.jsPdf.sendEmail.inputs.map(i => {
          if (i.value === 'cc')
            return {...i, hide: !enableCc}
          else if (i.value === 'bcc')
            return {...i, hide: !enableBcc}
          return i
        })
      } else {
        this.jsPDF.sendEmail.model = null
      }
    }
  },

  async created() {
    this.validatedDetails = !this.typeDetails || this.typeDetails === 'none'

    if (this.collection.includes('SC5') || this.collection.includes('SA1')) {
      this.observer({
        collection: 'SE4', 
        register: 'SE4',
        filters: [{key: 'active', operator: '==', value: true}],
        orderBy: 'indice',
        limit: 999
      })     
      this.observer({
        collection: 'DA0', 
        register: 'DA0',
        filters: [{key: 'active', operator: '==', value: true}],
        // orderBy: 'indice',
        limit: 999
      })
      this.observer({
        collection: 'SA4', 
        register: 'SA4',
        filters: [{key: 'active', operator: '==', value: true}],
        // orderBy: 'indice',
        limit: 999
      })      
      this.observer({
        collection: 'ZC3', 
        register: 'ZC3',
        filters: [{key: 'active', operator: '==', value: true}],
        // orderBy: 'indice',
        limit: 999
      })      
      this.observer({
          collection: 'SA1', 
          register: 'SA1X',
          filters: [{key: 'active', operator: '==', value: true}],
          forceFilter: true,
          // orderBy: 'indice',
          limit: 999
        })     
      this.observer({
          collection: 'SA2', 
          register: 'SA2',
          filters: [{key: 'active', operator: '==', value: true} ],
          forceFilter: true,
          // orderBy: 'indice',
          limit: 9999
        })     
      this.observer({
          collection: 'SA2', 
          register: 'SA2E',
          filters: [{key: 'active', operator: '==', value: true},{key: 'A2_XTPPAR', operator: '==', value: '1'} ],
          forceFilter: true,
          // orderBy: 'indice',
          limit: 9999
        })     
      this.observer({
          collection: 'SA2', 
          register: 'SA2I',
          filters: [{key: 'active', operator: '==', value: true}, {key: 'A2_XTPPAR', operator: '==', value: '2'}],
          forceFilter: true,
          // orderBy: 'indice',
          limit: 9999
        })     
      this.observer({
          collection: 'SA2', 
          register: 'SA2P',
          filters: [{key: 'active', operator: '==', value: true}, {key: 'A2_XTPPAR', operator: '==', value: '3'}],
          forceFilter: true,
          // orderBy: 'indice',
          limit: 9999
        })     
      this.observer({
        collection: 'ZC1', 
        register: 'ZC1',
        filters: [{key: 'active', operator: '==', value: true}],
        // orderBy: 'indice',
        limit: 999
      })  
      this.observer({
        collection: 'SM0', 
        register: 'SM0',
        filters: [{key: 'active', operator: '==', value: true}],
        // orderBy: 'indice',
        limit: 999
      })  
      this.observer({
        collection: 'SA3', 
        register: 'SA3RT',
        filters: [{key: 'active', operator: '==', value: true}, {key: 'A3_TIPO', operator: '==', value: 'P'}],
        forceFilter: true,
        // orderBy: 'indice',
        limit: 999
      })      
      if (this.collection.includes('SA1')) {
        this.observer({
          collection: 'AOV', 
          register: 'AOV',
          filters: [{key: 'active', operator: '==', value: true}],
          // orderBy: 'indice',
          limit: 999
        })     
      }
    }
    
    if (this.id) {
      let handleItem = false
      let item = this.registers[this.register] && this.registers[this.register].find(item => item.id === this.$route.params.id)      
      if (!item) {
        item = await this.getById({collection: this.collection, register: this.register, id: this.$route.params.id, getFilial: false})
      } 

      this.normalizeItem(item)
      
      /**
       * TO-DO
       * Tire isso daqui
       */
      if (this.claimRoute === 'add') {
        const { C5_CLIENTE, C5_LOJACLI, SA1, A1_NOME, A1_END, A1_EST, A1_MUN,  A4_NREDUZ, C5_FILIAL, C5_TABELA, C5_TRANSP, DA0_DESCRI, C5_NUM } = item
        this.item = { C5_CLIENTE, C5_LOJACLI, SA1, A1_NOME, A1_END, A1_EST, A1_MUN, A4_NREDUZ, C5_FILIAL, 
          C5_TABELA, DA0_DESCRI, C5_TRANSP, C5_XTIPO: 'B', C5_YPEDORI: C5_NUM
        }

        /**
         * TO-DO
         * Tirar essa gambiarra daqui depois. Ver essa lógica para colocar na computed
         */
        // setTimeout(()=>{
        //   const SE4 = this.registers.SE4.find(condPG => condPG.E4_CODIGO.trim() === '999')
        //   this.item = {...this.item, SE4}
        // },1500)
      } else 
        this.item = handleItem ? this.handleItem(item) : item 

      // se for criação, não puxe os impostos, pois é uma cópia
      if (this.claimRoute !== 'add' && (item.impostos || item.IMPOSTOS || item.Impostos) ) {
        this.calcImps(item.impostos || item.IMPOSTOS || item.Impostos)
      }
      
      await this.fetchDetails()

      if (item[this.tableIdFrom] && !this.readonlyComputed ) 
        await this.getTableItems({collection: this.tableCollection, subCollection: this.tableSubcollection, orderSubcollection: this.orderSubcollection, id: item[this.tableIdFrom]})
      
    } else {
      this.ready = true
    }

    this.$nextTick(() => {
        this.$refs.formMaster.$on('change:' + this.tableIdFrom, async (id) => {
          await this.getTableItems({collection: this.tableCollection, subCollection: this.tableSubcollection, orderSubcollection: this.orderSubcollection, id})
          this.inputsDetails = this.tableItems
          const inputTableIdFrom = this.inputsMaster.find(input => input.value == this.tableIdFrom)
          if (inputTableIdFrom && inputTableIdFrom.updateDetails) {
            const rules = eval(inputTableIdFrom.updateDetails)
            const formMaster = this.$refs.formMaster ? this.$refs.formMaster.getModel() : {}
            this.inputsDetails = this.inputsDetails.map(el => {
              return rules({item: formMaster, value: formMaster[this.tableIdFrom], detail: el})
            });
          }
        })
      })
    // this.startAutoSave()
    
    const inputNeedApproval = this.inputsMaster.filter(input => input.needApproval)        
    inputNeedApproval.forEach(el => {
      if (!el.on) el.on = {}
      if (!el.on.change) el.on.change = []
      const rules = eval(el.needApproval)
      el.on.change.push( 
        (value) => {
            const formMaster = this.$refs.formMaster ? this.$refs.formMaster.getModel() : {}
            this.needApproval = rules({value, item: formMaster})
        }
      )
      const formMaster = this.$refs.formMaster ? this.$refs.formMaster.getModel() : {}
      this.needApproval = formMaster[el.value] ? rules({value: formMaster[el.value], item: formMaster}) : false
    });
    
    const updateDetails = this.inputsMaster.filter(input => input.updateDetails)
    
    updateDetails.forEach(el => {
      if (!el.on) el.on = {}
      if (!el.on.change) el.on.change = []        
        const rules = eval(el.updateDetails)
        el.on.change.push(
        (value) => {
            const formMaster = this.$refs.formMaster ? this.$refs.formMaster.getModel() : {}
            this.inputsDetails = this.inputsDetails.map(el2 => {
              return rules({item: formMaster, value, detail: el2})
            });
        }
      )
      const formMaster = this.$refs.formMaster ? this.$refs.formMaster.getModel() : {}
      if (formMaster[el.value]) {
        this.inputsDetails = this.inputsDetails.map(el2 => {
          return rules({item: formMaster, value: formMaster[el.value], detail: el2})
        });      
      }
    });    

    const filterRegister = this.inputsMaster.filter(input => input.filterRegister)

    filterRegister.forEach(el => {
      if (!el.on) el.on = {}
      if (!el.on.change) el.on.change = []               
        const filter = eval(el.filterRegister.filter)
        el.on.change.push(
          (value) => {
            const formMaster = this.$refs.formMaster ? this.$refs.formMaster.getModel() : {}
            const ret = filter({register: this.$_.cloneDeep(this.registers[el.filterRegister.register]), value, item: formMaster })
            this.$set(this.registers, [`${el.filterRegister.register}Filtered`], ret)
          });        
        this.$set(this.registers, [`${el.filterRegister.register}Filtered`], this.$_.cloneDeep(this.registers[el.filterRegister.register]))
      }
    );   

    const filterRegister2 = this.inputsMaster.filter(input => input.filterRegister2)
    
    
    for await (let el of filterRegister2) {
      el.filterRegister2
      if (!el.on) el.on = {}
      if (!el.on.change) el.on.change = []
        el.on.change.push(
          async (value) => {
            let options = [] 
            const formMaster = await this.$refs.formMaster ? await this.$refs.formMaster.getModel() : {}
            const collection = el.filterRegister2.collection
            const register = el.filterRegister2.register
            const limit = el.filterRegister2.limit
            let filters2 = []
            filters2 = await el.filterRegister2.filters ? await eval(el.filterRegister2.filters) : []
            filters2 = await eval(filters2)
            
            options =  await this.get({collection: collection, forceFilter: true, limit: limit ? limit : 10 , register: register, filters: filters2})
            
            if (options && options.length > 0) {
              const ret = options //await this.get({collection: 'SA1',forceFilter: true,limit: 200, register: 'SA1X', filters: [{key: 'A1_COD', operator: '==', value: '000701'}, {key: 'A1_COD', operator: '==', value: '000701'}]})
              this.$set(this.registers, [`${el.filterRegister2.register}Filtered`], ret)
            }
            
          });         
        this.$set(this.registers, [`${el.filterRegister2.register}Filtered`], this.$_.cloneDeep(this.registers[el.filterRegister2.register]))
    }
       
  },

  beforeDestroy() {
    clearTimeout(this.autoSave.timer)
  },
}
</script>

<style></style>

